"use client"

import clsx from "clsx"
import React, { FC } from "react"

interface Props {
  icons: {
    selected: boolean
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
    onClick: () => void
  }[]
}

export const IconToggle: FC<Props> = ({ icons }) => {
  return (
    <div className="flex flex-row items-center gap-1 rounded-full bg-bg-1 px-3 py-1">
      {icons.map((_icon, index) => {
        const { Icon, onClick, selected } = _icon
        return (
          <div className="cursor-pointer px-1" key={index} onClick={onClick}>
            <Icon
              height={24}
              width={24}
              className={clsx("flex flex-shrink-0", selected ? "stroke-fg-1" : "stroke-fg-3 hover:stroke-fg-2")}
            />
          </div>
        )
      })}
    </div>
  )
}
